import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { XLarge } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import css from './FeatureProducts.module.scss';
import Image from '../Image';
import useEventListener from '../../utils/hooks/useEventListener';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var MOBILE_WIDTH = 667;

var getDescription = function getDescription() {
  var chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var hoverFunc = arguments.length > 1 ? arguments[1] : undefined;
  return chunks.map(function (_ref) {
    var copy = _ref.copy,
        url = _ref.url;

    if (!url) {
      return copy;
    }

    return /*#__PURE__*/_jsx("a", {
      className: css.descLink,
      href: url,
      onMouseEnter: function onMouseEnter() {
        return hoverFunc(true);
      },
      onMouseLeave: function onMouseLeave() {
        return hoverFunc(false);
      },
      children: copy
    }, copy);
  });
};

var ProductLine = function ProductLine(_ref2) {
  var title = _ref2.title,
      url = _ref2.url;
  return /*#__PURE__*/_jsx("li", {
    className: css.productLine,
    children: /*#__PURE__*/_jsx("a", {
      className: css.copy,
      href: url,
      children: title
    })
  });
};

ProductLine.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

var Product = function Product(_ref3) {
  var collab = _ref3.collab,
      collabUrl = _ref3.collabUrl,
      description = _ref3.description,
      hoverImageDesktop = _ref3.hoverImageDesktop,
      hoverImageMobile = _ref3.hoverImageMobile,
      imageDesktop = _ref3.imageDesktop,
      imageMobile = _ref3.imageMobile,
      products = _ref3.products,
      title = _ref3.title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInfo = _useState2[0],
      setShowInfo = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showAltImage = _useState4[0],
      setShowAltImage = _useState4[1];

  var _useState5 = useState(windowWidth()),
      _useState6 = _slicedToArray(_useState5, 2),
      width = _useState6[0],
      setWidth = _useState6[1];

  var isMobile = MOBILE_WIDTH >= width;
  useEventListener('resize', function () {
    setWidth(windowWidth());
  });
  var image = isMobile ? imageMobile : imageDesktop;
  var hoverImage = isMobile ? hoverImageMobile : hoverImageDesktop;
  return /*#__PURE__*/_jsxs("li", {
    className: cc([css.product, _defineProperty({}, css.showInfo, showInfo)]),
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.image, _defineProperty({}, css.hide, showAltImage)]),
      children: /*#__PURE__*/_jsx(Image, _objectSpread({}, image))
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.hoverImage, _defineProperty({}, css.hide, !showAltImage)]),
      children: hoverImage && /*#__PURE__*/_jsx(Image, _objectSpread({}, hoverImage))
    }), /*#__PURE__*/_jsxs("div", {
      className: css.leading,
      children: [/*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: title
      }), isMobile && /*#__PURE__*/_jsx("a", {
        className: cc([css.copy, css.collab]),
        href: collabUrl,
        children: collab
      }), !isMobile && /*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: getDescription(description, setShowAltImage)
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.trailing,
      children: [!isMobile && /*#__PURE__*/_jsx("a", {
        className: css.copy,
        href: collabUrl,
        children: collab
      }), isMobile && /*#__PURE__*/_jsx("button", {
        type: "button",
        className: css.info,
        onClick: function onClick() {
          return setShowInfo(true);
        },
        children: "Info"
      }), isMobile && /*#__PURE__*/_jsx("button", {
        type: "button",
        className: css.close,
        onClick: function onClick() {
          return setShowInfo(false);
        },
        children: /*#__PURE__*/_jsx(XLarge, {})
      }), /*#__PURE__*/_jsx("ul", {
        className: css.productLines,
        children: products.map(function (product) {
          return /*#__PURE__*/_createElement(ProductLine, _objectSpread(_objectSpread({}, product), {}, {
            key: product.title
          }));
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: css.mobileDescription,
      children: getDescription(description, function () {})
    })]
  });
};

Product.defaultProps = {
  hoverImageDesktop: false,
  hoverImageMobile: false
};
Product.propTypes = {
  collab: PropTypes.string.isRequired,
  collabUrl: PropTypes.string.isRequired,
  description: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  hoverImageDesktop: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  hoverImageMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  imageDesktop: PropTypes.shape().isRequired,
  imageMobile: PropTypes.shape().isRequired,
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  title: PropTypes.string.isRequired
};

var FeatureProducts = function FeatureProducts(_ref7) {
  var products = _ref7.products;
  return /*#__PURE__*/_jsx("section", {
    className: css.root,
    children: /*#__PURE__*/_jsx("ul", {
      className: css.products,
      children: products.map(function (product) {
        return /*#__PURE__*/_createElement(Product, _objectSpread(_objectSpread({}, product), {}, {
          key: product.title
        }));
      })
    })
  });
};

FeatureProducts.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired
};
export default FeatureProducts;